import { useState } from 'react';
import { formatNumber } from '@bookingdei/i18n/format-number';
import { useLanguage } from '../../shell/language-context';
import { QrImage } from './qr-image';
import { useCountUp } from './use-count-up';

// Below the hero search (design DC:446-464): the live "bookings made today" counter
// and, on desktop, "Get the app" with a QR popover on hover/focus. The count is the
// server's `stats.bookings_today` (API-86); it counts up on arrival and the pill is
// absent when the server sends no figure — a made-up number is worse than none.
export function HeroTickerRow({ bookingsToday, appUrl }: { bookingsToday: number | undefined; appUrl: string | undefined }) {
  const { t, lang } = useLanguage();
  const [qrOpen, setQrOpen] = useState(false);
  const count = useCountUp(bookingsToday, { from: bookingsToday ? Math.round(bookingsToday * 0.92) : 0, ms: 2400 });

  const scrollToApp = () => {
    const el = document.getElementById('app-download');
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  };

  return (
    <div className="hm-hero__row">
      {bookingsToday !== undefined ? (
        <div className="hm-ticker">
          <span className="hm-ticker__dot" aria-hidden="true" />
          <span className="hm-ticker__num">{formatNumber(lang, count)}</span>
          <span className="hm-ticker__lbl">{t('dc50.hero.bookings_today')}</span>
        </div>
      ) : null}
      <div
        className="hm-getapp"
        onMouseEnter={() => setQrOpen(true)}
        onMouseLeave={() => setQrOpen(false)}
        onFocus={() => setQrOpen(true)}
        onBlur={() => setQrOpen(false)}
      >
        <button type="button" className="hm-getapp__btn" onClick={scrollToApp} aria-expanded={qrOpen}>
          <span className="hm-getapp__ic" aria-hidden="true">
            ▦
          </span>
          {t('dc50.hero.get_app')}
        </button>
        {qrOpen && appUrl ? (
          <div className="hm-getapp__pop">
            <QrImage className="hm-getapp__qr" value={appUrl} label={t('dc50.hero.qr_label')} />
            <div className="hm-getapp__cap">{t('dc50.hero.scan_download')}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
